#tooltip.right {
  margin-left: 5px;
}

#tooltip.left {
  margin-left: -5px;
}

#tooltip.top {
  margin-top: -5px;
}

#tooltip.bottom {
  margin-top: 5px;
}

#tooltip .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #eeeeee;
}

#tooltip.right .tooltip-arrow {
  top: 50%;
  left: auto;
  margin-left: -15px;
  border-width: 5px 5px 5px 0;
  border-right-color: #eeeeee;
}

#tooltip.top .tooltip-arrow {
  top: auto;
  bottom: -5px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #eeeeee;
}

#tooltip.left .tooltip-arrow {
  top: 50%;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #eeeeee;
  right: -5px;
  left: auto;
}

#tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #eeeeee;
}

#tooltip .tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

#tooltip .tooltip-label {
  color: black;
  text-align: center;
  border-radius: 4px;
}
